export const apiKey2 = "fd716ec13df2448a93c2bc46b2eba808";
export const apiKey3 = "e27b4ab11ff94caf9325aaa456a7e56b";
export const apiKey = "0676813fa9e445c1939fb3ad54249686";
export const apiKey4 = "6ded234ca27e487caddf2b013b8a2fbe";

// colors;
// #f39fa8 light
// #ebbfc2 lighter
// #3f201f dark
// #fcb4a4 almost skin
// #ebbfc2 light pink
// #fbebe3 cream
// #fc8471 orange

// adobe color
// #F2A7C3 light Pinkish
// #F25E3D orangish
// #401E1B brownish
// #F2DEDC skinish
// #F27979 pinkishred

// optimizations
/*
1. combine joke and fact component
2.







*/
